import { required } from '@vuelidate/validators';

export default {
  title: {
    required,
  },
  projectId: {
    required,
  },
};
